import React from 'react';

import { LinkWithPulse } from '../../../../core/mandatory-integrations/pulse/components/LinkWithPulse.js';

export type NextPaginationProps = {
  pageCount: number;
  pageId: string;
  currentPage: number;
  location: string;
};

const NextPagination: React.FC<NextPaginationProps> = ({
  pageCount,
  currentPage,
  pageId,
  location,
}) => {
  const lastPage = currentPage >= pageCount;
  const text = !lastPage ? 'Neste' : 'Forrige';
  const direction = !lastPage ? currentPage + 1 : currentPage - 1;
  const nextClass = ['next-page', lastPage ? 'last' : ''].join(' ');

  return (
    <div className="next-pagination">
      <div>{`Side ${currentPage} av ${pageCount}`}</div>
      {pageCount > 1 && (
        <LinkWithPulse
          className={nextClass}
          objectId={`page-${direction}`}
          name="Next pagination element"
          key={`page-${direction}`}
          href={`/${location}/${pageId}?page=${direction}`}
        >
          {text}
        </LinkWithPulse>
      )}
    </div>
  );
};

export default NextPagination;
